/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    // "aws_cognito_identity_pool_id": "eu-west-2:ecd1ac5d-8f39-4eb4-be09-57a468d5cfb2",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_eP98jupZ8",
    "aws_user_pools_web_client_id": "6otnb732k51c24e2sai475047t",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
